var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiren(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.257,
    height: 49.225,
    viewBox: "0 0 56.257 49.225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.709,31.645H42.193V17.58a17.58,17.58,0,1,0-35.161,0V31.645H3.516a3.516,3.516,0,1,0,0,7.032H45.709a3.516,3.516,0,1,0,0-7.032Zm-35.161,0V17.58a14.02,14.02,0,0,1,9.5-13.242,14.027,14.027,0,0,0-5.984,11.484V31.645Z",
    transform: "translate(3.516 11.548)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.758,7.032A1.757,1.757,0,0,0,3.516,5.274V1.758A1.758,1.758,0,1,0,0,1.758V5.274A1.757,1.757,0,0,0,1.758,7.032Z",
    transform: "translate(26.371 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.274,0H1.758a1.758,1.758,0,0,0,0,3.516H5.274A1.758,1.758,0,1,0,5.274,0Z",
    transform: "translate(49.225 27.371)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.032,1.758A1.757,1.757,0,0,0,5.274,0H1.758a1.758,1.758,0,0,0,0,3.516H5.274A1.757,1.757,0,0,0,7.032,1.758Z",
    transform: "translate(0 27.371)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.807,6.051A1.752,1.752,0,0,0,3.05,5.536L5.536,3.05A1.758,1.758,0,0,0,3.05.564L.564,3.05a1.758,1.758,0,0,0,1.243,3Z",
    transform: "translate(42.481 8.675)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05,5.536A1.758,1.758,0,0,0,5.536,3.05L3.05.564A1.758,1.758,0,0,0,.564,3.05L3.05,5.536Z",
    transform: "translate(7.675 8.675)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiren);
export default __webpack_public_path__ + "static/media/siren.d4f65b49b367fe7def49c0cba8451dae.svg";
export { ForwardRef as ReactComponent };